import { css } from "@emotion/css";
import { theme } from "../../utils/theme";

export const sparkInputNoLabelCSS = css`
  .spark-label {
    display: none;
  }

  &&.spark-input .spark-input__field {
    padding: 0rem 5rem 0rem 1rem;
    height: 4rem;
    background-color: ${theme.palette.gray[10]};
    font-weight: 400;
  }

  .spark-input__field::-webkit-input-placeholder {
    padding: 0.5rem 0;
    opacity: 1;
    color: ${theme.palette.gray[70]};
  }
`;

export const submitButton = css`
  &&.spark-btn--icon {
    padding: 0.8rem;
    width: 3rem;
    height: 3rem;
    margin-top: -15px;
    margin-right: -6px;
  }
`;
